SharedFooterUSPhoneNumberView = require('./phone_number_view')
SupportPhoneNumberCallBackView = require('../../../../../support/frontend/views/email_form/US/phone_number_call_back_view')
Backbone = require 'backbone'
Backbone.$ = $
SharedFooterLoggedTemplate = require('../../../../footer_logged.html.mustache')
SharedFooterNotLoggedTemplate = require('../../../../footer_not_logged.html.mustache')
SharedFooterLinksTemplate = require('../../../../footer_links.html.mustache')

class SharedFooterUSMainView extends Backbone.View
  class: 'box support-footer'

  initialize: () ->
    @I18nScope = 'modules.shared'
    @user = window.currentUser
    @template = if @user?  then SharedFooterLoggedTemplate else SharedFooterNotLoggedTemplate
    @footerLinkTemplate = SharedFooterLinksTemplate

  render: ->
    @$el.append toHtml(@template, {id: @user?.id, faqInsteadHelpWizard: window.faqInsteadHelpWizard}, @I18nScope)
    @$el.find('.support_help').html toHtml(@footerLinkTemplate, @user, @I18nScope)

  renderPhoneNumberView: ->
    if experiments.shouldDisplayCallBackOption and not(window.isFAQ)
      @renderPhoneNumberCallBackView()
    else
      @renderNormalPhoneNumberView()

  renderNormalPhoneNumberView:()->
    propagateEventBeforeReplacingElements( () =>
      phoneNumberView = new SharedFooterUSPhoneNumberView()
      phoneNumberView.render()
    )

  renderPhoneNumberCallBackView:()->
    propagateEventBeforeReplacingElements( () =>
      @phoneNumberCallBackView = new SupportPhoneNumberCallBackView
                                  mainView: this
      @phoneNumberCallBackView.render()
    )

  events :
    "click span.lnk-call-us"  : "renderPhoneNumberView"

module.exports = SharedFooterUSMainView
